exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-section .col-md-6 {\n    width: 50%;\n}\n\n.form-line {\n    border-right: 2px solid #B29999;\n}\n\n.form-group {\n    margin-top: 10px;\n}\n\nlabel {\n    font-size: 1.3em;\n    line-height: 1em;\n    font-weight: normal;\n}\n\n.form-control {\n    font-size: 1.3em;\n    color: #080808;\n}\n\ntextarea.form-control {\n    height: 135px;\n    /* margin-top: px;*/\n}\n\n.content-header {\n    font-family: 'Oleo Script', cursive;\n    color: #fcc500;\n    font-size: 22px;\n}\n\n.section-content {\n    text-align: center;\n}\n\n#contact {\n    font-family: 'Teko', sans-serif;\n    padding-top: 10px;\n    width: 100%;\n    width: 100vw;\n    height: 367px;\n    background: #3a6186;\n    /* fallback for old browsers */\n    /* Chrome 10-25, Safari 5.1-6 */\n    background: linear-gradient(to left, #1f66a93b, #89253e87);\n    color: #fff;\n}\n\n.phone-contact {\n    font-family: 'Oleo Script', cursive;\n    color: #a4ca19;\n    font-size: 22px;\n}\n\n.submit {\n    border-width: thick;\n    border-color: #e3900b;\n    font-size: 1.1em;\n    float: right;\n    width: 150px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/Techbotz-master/src/app/contact/contactUs.component.css
// module id = ../../../../../src/app/contact/contactUs.component.css
// module chunks = main